<template>
  <div class="flex flex-col flex-shrink-0 mx-4 py-8 text-center bg-white border-2 border-gray-200 rounded-lg dark:bg-gray-800 dark:border-gray-700 plan-A" style="height:385px; width:220px;">
    <div class="text-center">
        <h2 class="font-semibold uppercase text-blue-dark">
          {{ plansListAData.plan_a_title }}
        </h2>
        <!-- <span class="text-gray-500">適合初階使用者</span> -->
    </div>
    <div class="text-gray-700 text-center font-mono flex flex-wrap justify-center content-center py-4 my-4 bg-plan-A">
      <div class="text-white">
        <p class="text-3xl">${{ plansListAData.plan_a_label_amount }}<span class="text-sm ml-2">/{{lang['components']['Plan']['PlanA']['time_unit']}}</span></p>
        <p v-if="false" class="text-sm">per month</p>
      </div>
    </div>
    <ul class="flex-1 space-y-2 text-gray-500 dark:text-gray-400 text-sm">
      <li v-for="(item, index) in description" class="border-b">
          {{ item }}
      </li>
    </ul>
    <!--<button v-if="plansListAData.plan_a_show" class="rounded-full bg-plan-A mx-16 py-2 mt-12" :disabled="isDisabled" @click="handleChickPlan(2, 'A')">
      {{ plansListAData.plan_a_text }}
    </button>-->
    <button v-if="plansListAData.plan_a_show" class="rounded-2xl bg-plan-A mx-16 p-2 mt-auto text-sm" @click="handleChickPlan(2, 'A', '', 'fb')">
      {{ plansListAData.plan_a_text }}
    </button>
    <button v-else-if="!plansListAData.planHaveBind" class="rounded-2xl bg-plan-A mx-16 p-2 mt-auto text-sm" @click="handleChickPlan(2, 'A', '', 'fb')">
      {{lang['components']['Plan']['PlanA']['is_expired']}}
    </button>
    <button
      v-else
      class="rounded-2xl bg-plan-A mx-16 p-2 mt-auto text-sm"
       v-if="isExpiredData && (plansListAData.plan_a_text == '使用中' || plansListAData.plan_a_text == 'Using')"
      @click="handleChickPlan(2, 'A', 'payAgain', 'fb')"
    >
      {{lang['components']['Plan']['PlanA']['plan_item_payagain_button_text']}}
    </button>
  </div>
</template>

<script>
export default {
  name: 'PlanA',
  props: {
    handleChickPlan: {
      type: Function,
      default: () => ({})
    },
    plansListA:{
      type:Object,
      required:true
    },
    isExpired: {
      type: Boolean
    },
    lang: {
      type: Object
    },
  },
  computed: {
    plansListAData: {
      get: function () {
        return this.plansListA
      },
      set: function (value) {
        this.$emit('update:plansListAData', value)
      },
    },
    isExpiredData: {
      get: function () {
        return this.isExpired
      },
      set: function (value) {
        this.$emit('update:isExpiredData', value)
      },
    },
    description: function() {
       return this.plansListA.plan_a_description
    },
    isDisabled: function() {
       return this.plansListA.plan_a_disable
    }
  }
}
</script>

<style lang="scss" scope>
  .plan-A {
    &:hover {
      border: 2px #6298D7 solid;
    }
  }
</style>